import { ColumnDetails, ColumnType } from '../../../../../../../grid/types/common';
import {
  Column,
  ColumnKeys,
} from '../../../../../../integrityMonitor/realTime/integrityMonitorPolicyRuleSetsSection/types';

export namespace IntegrityMonitorRuleSets {
  export function getGridColumnDetails(translatedStrings: {
    ruleSet: string;
    rules: string;
    actions: string;
  }): Array<ColumnDetails<Column, ColumnKeys>> {
    return [
      {
        column: Column.RULE_SET_NAME,
        key: ColumnKeys.RULE_SET_NAME,
        columnName: translatedStrings.ruleSet,
        type: ColumnType.STRING,
        removable: false,
        filteringDisabled: true,
      },
      {
        column: Column.RULES_COUNT,
        key: ColumnKeys.RULES_COUNT,
        columnName: translatedStrings.rules,
        type: ColumnType.NUMBER,
        removable: false,
        filteringDisabled: true,
      },
      {
        column: Column.ACTIONS,
        key: ColumnKeys.ACTIONS,
        columnName: translatedStrings.actions,
        type: ColumnType.ACTION,
        removable: false,
        filteringDisabled: true,
      },
    ];
  }
}
